import * as React from 'react';
import type {ChatPanelHandle} from './chat-panel';
import {create} from 'zustand';


export const useAutoAttachStore = create<{
  shouldAutoAttach: boolean;
  setShouldAutoAttach: (value: boolean) => void;
  headerSlot: React.ReactNode | null;
  setHeaderSlot: (node: React.ReactNode | null) => void;
}>((set) => ({
  shouldAutoAttach: false,
  setShouldAutoAttach: (value) => set({shouldAutoAttach: value}),
  headerSlot: null,
  setHeaderSlot: (node) => set({headerSlot: node}),
}));

export const useRespondToAutoAttach = (
  chatPanelRef: React.RefObject<ChatPanelHandle | null>,
) => {
  const {shouldAutoAttach, headerSlot} = useAutoAttachStore();

  React.useEffect(() => {
    if (shouldAutoAttach) {
      chatPanelRef.current?.setMode('attached');
    } else {
      // Detaching from an attach host: drop back to the floating (minimized)
      // chat. Panel mode isn't persisted, so there's no prior mode to restore.
      chatPanelRef.current?.setMode('floating');
      chatPanelRef.current?.setOpen(false);
    }
  }, [shouldAutoAttach]);
  //for now headerSlot is only used in attached mode
  //change later if needed
  return {headerSlot: shouldAutoAttach ? headerSlot : null};
};

export const useRequestToAutoAttach = () => {
  const {setShouldAutoAttach} = useAutoAttachStore();

  React.useEffect(() => {
    setShouldAutoAttach(true);
    return () => {
      setShouldAutoAttach(false);
    };
  }, []);
};

export const useHeaderSlot = (headerSlot: React.ReactNode | null) => {
  const {setHeaderSlot} = useAutoAttachStore();
  React.useEffect(() => {
    setHeaderSlot(headerSlot);
    return () => {
      setHeaderSlot(null);
    };
  }, [headerSlot]);
};
